import { render, staticRenderFns } from "./dummy.vue?vue&type=template&id=518ac0e2"
import script from "./dummy.vue?vue&type=script&lang=js"
export * from "./dummy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports